import { render, staticRenderFns } from "./shuLiangBiLi.vue?vue&type=template&id=7cb10088&scoped=true&"
import script from "./shuLiangBiLi.vue?vue&type=script&lang=js&"
export * from "./shuLiangBiLi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb10088",
  null
  
)

export default component.exports